import { render, staticRenderFns } from "./myCustomer.vue?vue&type=template&id=28a5052e&scoped=true&"
import script from "./myCustomer.vue?vue&type=script&lang=js&"
export * from "./myCustomer.vue?vue&type=script&lang=js&"
import style0 from "./myCustomer.vue?vue&type=style&index=0&id=28a5052e&lang=scss&scoped=true&"
import style1 from "./myCustomer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5052e",
  null
  
)

export default component.exports